import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";;
import * as Sentry from '@sentry/angular';
import { MatDialog } from "@angular/material/dialog";
import { EstatusJSON } from "../../../shared/models/EstatusJSON";
import { CatalogPaginationRequest } from "../../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../../shared/models/Filter/FilterRequest";
import { ActiveAlarmsListComponent } from "../components/active-alarms-list/active-alarms-list.component";
import { AlarmAPIService } from "../../../shared/services/API/AlarmAPI.service";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AlarmService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();

  public isAlarmListVisible: boolean = false;
  public listDialogRef: any;

  subscription_GetAlarms: Subscription;

  public Result;
  estatus: EstatusJSON;
  constructor(private dialog: MatDialog, private alarmService: AlarmAPIService) {
    this.estatus = new EstatusJSON();
  }

  ToggleAlarms(isDesktop: boolean){
    if(this.listDialogRef){
      this.listDialogRef.close();
      this.listDialogRef = null;
    }

    if (isDesktop) {
      if(!environment.production) console.log('alarm event', event);
      this.listDialogRef = this.dialog.open(ActiveAlarmsListComponent, {
        width: "auto",
        maxWidth: "100vw",
        height: "fit-content",
        autoFocus: false,
        restoreFocus: false,
        data: event
      });
      
  
      this.listDialogRef.afterClosed().subscribe(reload => {
        if(!environment.production) console.log('cerrado');
        this.listDialogRef = null;
      });
    }else{
      if(!environment.production) console.log('alarm event', event);
      this.listDialogRef = this.dialog.open(ActiveAlarmsListComponent, {
        width: "fit-content",
        maxWidth: "100vw",
        maxHeight: "calc(100vh - 65px)",
        height: "fit-content",
        autoFocus: false,
        restoreFocus: false,
        disableClose: true,
        hasBackdrop: false,
        data: event
      });
  
      this.listDialogRef.afterClosed().subscribe(reload => {
        if(!environment.production) console.log('cerrado');
        if (this.subscription_GetAlarms)
          this.subscription_GetAlarms.unsubscribe();
        this.listDialogRef = null;
      });
    }
}

checkAlarms(isDesktop: boolean): any {
  this.subscription_GetAlarms = this.getImportantAlarmsPage(1).subscribe({
    next: (data) => {
      if (data.isSuccess) {
        if (data.result.length > 0) {
          this.isAlarmListVisible = true;
          this.ToggleAlarms(isDesktop);
        }
      } else {
        Sentry.captureMessage('AlarmService.checkAlarms: respuesta sin éxito', { level: 'warning', extra: { response: data } });
      }
    },
    error: (error) => {
      // TODO marca para complete despues
      console.error('Error al verificar alarmas importantes', error);
    }
  })
}

setLoading(resp) {
  this.isLoading$.next(resp);
}

getLoading() {
  return this.isLoading$.asObservable();
}




getById(id): any {
  return this.alarmService.getById(id);
}

getImportantAlarmsPage(page): any {
  return this.alarmService.getImportantAlarmsPage(page);
}

DeactivateAlarms(idAlarm): any {
  return this.alarmService.DeactivateAlarms(idAlarm);
}

GetIdStatusActiveAlarms(): any {
  return this.GetIdStatusActiveAlarms();
}

delete(UserId): any{
  if(!environment.production) console.log("no hay delete");
}

//paginacion
getFilterValues(request : FilterRequest[]): any {
  return this.alarmService.getFilterValues(request);
}

getPage(request : CatalogPaginationRequest): any {
  return this.alarmService.getPage(request);
}
getCount(request : CatalogPaginationRequest): any {
  return this.alarmService.getCount(request);
}
  
}
